import React, { memo } from 'react';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import Grid from '../../Utils/Grid/Grid';
import Col from '../../Utils/Col/Col';
import ButtonLink from '../../ButtonLink/ButtonLink';
import { ButtonType } from '../../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../../interfaces/enums/ButtonSize.enum';
import { pushToDataLayer } from '../../../utils/pushToDataLayer/pushToDataLayer.util';
import { getDataLayerQuoteFunnerJourney } from '../../../utils/getDataLayerQuoteFunnelJourney/getDataLayerQuoteFunnelJourney.util';
import { ProductType } from '../../../services/quote.interfaces';

interface SubmitFormSectionButtonsProps {
  selectedProductType: ProductType;
}

const SubmitFormSectionButtons: React.FC<SubmitFormSectionButtonsProps> = ({
  selectedProductType,
}) => {
  const cancelButtonLabel: string = 'Cancel';
  const getFreeQuoteButtonLabel: string = 'Get your quote';

  return (
    <div className="p-10">
      <Grid gapX="gap-x-6" gapY="gap-y-6">
        <Col span={{ sm: 6 }}>
          <ButtonLink
            url="/"
            label={cancelButtonLabel}
            type={ButtonType.TERTIARY}
            size={ButtonSize.XL}
            className="w-full flex-shrink-0 uppercase"
          >
            {cancelButtonLabel}
          </ButtonLink>
        </Col>
        <Col span={{ sm: 6 }}>
          <ButtonLink
            url=""
            label={getFreeQuoteButtonLabel}
            type={ButtonType.PRIMARY}
            size={ButtonSize.XL}
            className="w-full flex-shrink-0 uppercase"
            btnType="submit"
            onClick={() => {
              window.sessionStorage.setItem('form_submit', 'true');
            }}
          >
            {getFreeQuoteButtonLabel}
          </ButtonLink>
        </Col>
      </Grid>
    </div>
  );
};

export default memo(withBlokWrapper(SubmitFormSectionButtons, Theme.DARKEST));
